import { assertWixPalette, COLORS, getColorValue, isRicosPalette, presets } from "../palettes";
import {
  adaptForeground,
  canTransformToHex,
  toCssRgb,
  toHexFormat,
  toRgbTuple
} from "../themeUtils";
import { isRicosPaletteRgb } from "./identifiers";
const createCssVars = (colors, config) => {
  const { contentBgColor = false, focusActionColor, settingsActionColor } = config || {};
  const isPaletteRgb = isRicosPaletteRgb(colors);
  const {
    textColor,
    bgColor: backgroundColor,
    actionColor,
    fallbackColor = isPaletteRgb ? "0, 0, 0" : "#000000",
    disabledColor,
    textColorLow
  } = colors;
  const parseColors = (obj) => Object.keys(obj).reduce((acc, key) => {
    const value = obj[key];
    if (value !== void 0) {
      const transformedValue = canTransformToHex(value) && isPaletteRgb ? toRgbTuple(toHexFormat(value)) : void 0;
      const colorValue = transformedValue !== void 0 ? transformedValue : value;
      acc[key] = isPaletteRgb ? toCssRgb(colorValue) : colorValue;
      acc[`${key}Tuple`] = isPaletteRgb ? colorValue : toRgbTuple(colorValue);
    }
    return acc;
  }, {});
  const parsedValues = parseColors({
    textColor,
    actionColor,
    backgroundColor,
    fallbackColor,
    disabledColor,
    textColorLow,
    settingsActionColor,
    focusActionColor
  });
  const bgColorContainer = !contentBgColor || backgroundColor === void 0 ? void 0 : isPaletteRgb ? toCssRgb(backgroundColor) : backgroundColor;
  const actionColorFallback = isPaletteRgb ? `rgb(${fallbackColor})` : adaptForeground(actionColor, fallbackColor);
  const actionColorFallbackTuple = isPaletteRgb ? fallbackColor : toRgbTuple(adaptForeground(actionColor, fallbackColor));
  return {
    ...parsedValues,
    ...actionColorFallback && { actionColorFallback },
    ...actionColorFallbackTuple && { actionColorFallbackTuple },
    ...bgColorContainer && { bgColorContainer }
  };
};
const extractColors = (palette) => {
  if (typeof palette === "string") {
    if (palette in presets) {
      return presets[palette];
    } else {
      console.error(`Palette ${palette} is unknown. Supported themes: ${presets}`);
      return {};
    }
  } else if (Array.isArray(palette)) {
    assertWixPalette(palette);
    return {
      actionColor: getColorValue(palette, COLORS.ACTION_COLOR),
      bgColor: getColorValue(palette, COLORS.BG_COLOR),
      textColor: getColorValue(palette, COLORS.TEXT_COLOR),
      disabledColor: getColorValue(palette, COLORS.DISABLED_COLOR),
      textColorLow: getColorValue(palette, COLORS.TEXT_COLOR_LOW)
    };
  } else if (palette && (isRicosPalette(palette) || isRicosPaletteRgb(palette))) {
    return palette;
  }
  console.error("Unrecognized Palette object. Please refer to Ricos Theme Documentation");
  return {};
};
function createPalette(palette, config) {
  if (!palette) {
    return { paletteVarsObject: {} };
  }
  const isPaletteRgb = isRicosPaletteRgb(palette);
  const colors = extractColors(palette);
  const areColorValuesValid = validateColors(colors, isPaletteRgb);
  if (!areColorValuesValid) {
    return { paletteVarsObject: {}, colors };
  }
  const transformedColors = transformColorsToHex(colors, isPaletteRgb);
  return { paletteVarsObject: createCssVars(transformedColors, config), colors: transformedColors };
}
function validateColors(colors, isPaletteRgb) {
  return !!Object.entries(colors).length && Object.entries(colors).every(([colorName, value]) => {
    if (value && typeof value === "string" && !isPaletteRgb && !canTransformToHex(value)) {
      console.error(
        `Invalid color value '${value}' for ${colorName}. Please refer to Ricos Theme Documentation`
      );
      return false;
    }
    return true;
  });
}
function transformColorsToHex(colors, isPaletteRgb = false) {
  return Object.entries(colors).reduce((acc, [key, value]) => {
    acc[key] = value && typeof value === "string" && !isPaletteRgb && canTransformToHex(value) ? toHexFormat(value) : value;
    return acc;
  }, {});
}
export {
  createPalette as default
};
//# sourceMappingURL=palette.js.map
